import { render } from "./TemplateImportMethodModal.vue?vue&type=template&id=15b02a38&scoped=true"
import script from "./TemplateImportMethodModal.vue?vue&type=script&lang=ts"
export * from "./TemplateImportMethodModal.vue?vue&type=script&lang=ts"

import "./TemplateImportMethodModal.vue?vue&type=style&index=0&id=15b02a38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15b02a38"

export default script